/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.FinancialInstitutionsResponse,
  (_params: vp.FinancialInstitutionsRequest) => void,
  () => void,

  (_params?: vp.FinancialInstitutionsRequest) => Promise<vp.FinancialInstitutionsResponse>,
];

function useFetchFinancialInstitutions({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.FinancialInstitutionsRequest>();
  const [response, setResponse] = useState<vp.FinancialInstitutionsResponse>({
    Success: false,
    ErrorMessage: '',
    FinancialInstitutions: {},
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setPending] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.FinancialInstitutionsRequest) => {
      setPending(true);

      const res = await api.fetchFinancialInstitutions(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setPending(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: vp.FinancialInstitutionsRequest) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        FinancialInstitutions: {},
      });
      setSendRequest(false);
    },
    async (_params: vp.FinancialInstitutionsRequest = {}) => {
      try {
        setPending(true);

        const res = await api.fetchFinancialInstitutions(_params, source);

        return res;
      } finally {
        setPending(false);
      }
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchFinancialInstitutions);
